/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuFilterOrigin_viewer$ref = any;
export type SbSharedRefineMenuFilterOrigin_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilterOrigin_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterOrigin_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '14194ad7a0d4d805cf2e7d5c2687e616';
export default node;
